import { Card } from '../../../components/Base/Base'

interface ProfileEmploymentProps {
  renderEmployment?: () => React.ReactNode
}

export function ProfileEmployment({ renderEmployment }: ProfileEmploymentProps) {
  return (
    <Card hasSubtleShadow smallerPadding align="left">
      {renderEmployment?.()}
    </Card>
  )
}
